import { useEffect, useRef, useState } from 'react';
import { useLocale } from 'next-intl';

//* Styles
import HeroHomeStyle from './style';

//* Components
import Text from '@/components/Text';
import Image from '@/components/Image';
import Container from '@/components/Container';
import { textWriter } from '@/components/Animation/util';
import useTrigger from '@/components/Animation/useTrigger';

//* Data
import { dataHomeHeroSection } from '@/data';

const HeroHome = () => {
	//! Navigation
	const lang = useLocale();

	//! Ref
	const styleRef = useRef();
	const refText = useRef();

	//! State
	const [load, setLoad] = useState(false);

	useEffect(() => {
		const trigger = useTrigger({
			ref: styleRef.current,
			documentPercent: 20,
			once: true,
			onEnter: () => {
				if (load) {
					styleRef.current.classList.add('active');

					setTimeout(() => {
						textWriter(refText.current.children[0]);
					}, 400);
				}
			},
		});
		return () => {
			trigger();
		};
	}, [load]);

	return (
		<HeroHomeStyle ref={styleRef}>
			<div className='hero-container'>
				<div className='image-block'>
					<Image
						onLoad={setLoad}
						src={dataHomeHeroSection[lang].image.src}
						alt={dataHomeHeroSection[lang].image.alt}
					/>
				</div>

				<div className='info-block'>
					<Container>
						<div className='info-inner-block'>
							<Text
								ref={refText}
								tag={'h1'}
								className={'font-montserrat-arm-bold uppercase text-secondary-color h1-block all-text-hero'}>
								{lang == 'en' ? (
									<>
										<span className='hero-title align-center'>{dataHomeHeroSection[lang].title1}</span>

										<span className='logo-text-animation hero-title align-center'>{dataHomeHeroSection[lang].title2}</span>

										<span className='logo-text-animation hero-titleL hover-primary-color align-center'>
											<span className='black shadow'>Net</span> <span className='background-secondary-color shadow'>Space</span>
										</span>
									</>
								) : (
									<>
										<span className='hero-title'>{dataHomeHeroSection[lang].title1}</span>

										<span className='logo-text-animation'>
											<span className='hero-titleL'>
												<span className='black shadow'>Net</span> <span className='background-secondary-color shadow'>Space</span>
											</span>
											<span>-ի</span>
										</span>

										<span className='logo-text-animation hero-title align-end'>{dataHomeHeroSection[lang].title2}</span>
									</>
								)}
							</Text>
						</div>
					</Container>
				</div>
			</div>
		</HeroHomeStyle>
	);
};

export default HeroHome;
